<script setup lang="ts">
const nextFrame = () => {
    return new Promise(resolve => {
        requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
        });
    });
};

await nextFrame();
</script>
<template>
    <slot></slot>
</template>
